






























































































































import AdditionDrawerForm from "@/components/Additions/AdditionDrawerForm.vue";
import AdditionIcon from "@/components/Additions/AdditionIcon.vue";
import ApprovalInfo from "@/components/ApprovalInfo.vue";
import ApprovalsList from "@/components/ApprovalsList.vue";
import EmployeeApprovalsFiles from "@/components/EmployeeApprovalsFiles.vue";
import EmployeeAttendDayApprove from "@/components/EmployeeAttendDayApprove.vue";
import EmployeeAttendEditMobile from "@/components/EmployeeAttendEditMobile.vue";
import EmployeeAttendMonthApprove from "@/components/EmployeeAttendMonthApprove.vue";
import EmployeeSummary from "@/components/EmployeeSummary.vue";
import ReportMissingEvent from "@/components/ReportMissingEvent.vue";
import Reports from "@/components/Reports.vue";
import { apiService, AppConstants, Interfaces, Models } from "@/core/Export";
import store from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    ReportMissingEvent,
    Reports,
    EmployeeAttendDayApprove,
    EmployeeAttendMonthApprove,
    EmployeeAttendEditMobile,
    EmployeeApprovalsFiles,
    ApprovalsList,
    ApprovalInfo,
    EmployeeSummary,
    AdditionDrawerForm,
    AdditionIcon
  }
})
export default class AppDrawer extends Vue {
  @Prop() isRightDrawerOpen: boolean;
  monthSelectOptions: Array<any>;
  yearSelectOptions: Array<any>;
  $q: any;
  permissions: any;
  hour: string;
  minutes: string;
  seconds: string;
  today: string;
  day: string;
  isPunchOut: boolean;
  punchInOutModel: Models.PortalLogDto;
  isInPunchInOutProccess: boolean;
  attendSpecialEventSelectOptions: Array<any>;
  isAttendSpecialEventVisible: boolean;
  selectedAttendSpecialEventId: number;

  constructor() {
    super();
    this.permissions = AppConstants.Permissions;

    this.selectedYear = this.appEnv.UserInfo.currentAttendYear;
    this.selectedMonth = this.appEnv.UserInfo.currentAttendMonth;

    this.yearSelectOptions = this.generateYears(this.appEnv.UserInfo.numberActiveYears, 1);
    this.hour = null;
    this.minutes = null;
    this.seconds = null;
    this.monthSelectOptions = this.generateMonths(1, 12);
    this.day = null;
    this.today = this.appEnv.formatDate(new Date().toString());
    this.isPunchOut = false;
    this.isInPunchInOutProccess = false;
    this.attendSpecialEventSelectOptions = [];
    this.selectedAttendSpecialEventId = 0;
  }

  created() {
    this.updateClock();
    this.fillDay();
    this.getAttendSpecialEvents();
    setInterval(this.updateClock, 1000);
  }

  userHelpVideo() {
    this.$q.dialog({
      title: this.$t('userHelpVideo.title'),
      message: this.$t('userHelpVideo.messageManagerAndEmployee'),
      html: true,
      focus: "none",
      ok: this.$t('close'),
    }).onOk();
  }

  @Watch("employeeAdditionalJobKey")
  getAttendSpecialEvents() {
    this.isInPunchInOutProccess = true;
    this.attendSpecialEventSelectOptions = [];
    this.appEnv.isBusy = true;
    apiService.getAttendSpecialEvents(this.appEnv.UserInfo.employeeId, this.selectedYear, this.selectedMonth)
      .then(res => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0];
        if (call && call.isSuccess) {
          this.attendSpecialEventSelectOptions = call.callResult.data;
          this.selectDefaultAttendSpecialEventSelectOption();
        } else {
        }
      }).catch(err => { })
      .finally(() => {
        this.isInPunchInOutProccess = false;
        this.appEnv.isBusy = false;
      })
  }

  fillDay() {
    this.day = this.$t("dayOfWeek." + new Date().getDay().toString()) as string;
  }

  updateClock() {
    let today = new Date();
    this.hour = today.getHours().toString();
    if (this.hour.length == 1) {
      this.hour = `0${this.hour}`;
    }
    this.minutes = today.getMinutes().toString();
    if (this.minutes.length == 1) {
      this.minutes = `0${this.minutes}`;
    }
    this.seconds = today.getSeconds().toString();
    if (this.seconds.length == 1) {
      this.seconds = `0${this.seconds}`;
    }
  }

  @Watch("selectedYear")
  @Watch("selectedMonth")
  onYearOrMonthChanged() {
    this.selectDefaultAttendSpecialEventSelectOption();
    this.getAttendSpecialEvents();
    this.onCloseRightDrawerAfterAction();
  }

  onNavigateToRoute(path: string) {
    if (this.$route.path != path) {
      this.$router.push({ path: path });
    }
    this.onCloseRightDrawerAfterAction();
  }

  onCloseRightDrawerAfterAction() {
    if (this.$q.screen.xs) {
      this.isRightDrawerOpenLocal = false;
    }
  }

  onRequestUserGeoLocation(isPunchOut: boolean = false) {
    if (this.appEnv.UserInfo.forceSpecialEvent && this.selectedAttendSpecialEventId < 1) {
      this.appEnv.showErrorDialog([{ message: this.$t('msgs.must_select_special_event') }]);
      return;
    }
    this.onStartPunchProcess(isPunchOut);
  }

  onStartPunchProcess(isPunchOut: boolean = false) {
    this.punchInOutModel = new Models.PortalLogDto();
    this.punchInOutModel.latitude = 0;
    this.punchInOutModel.longitude = 0;
    this.punchInOutModel.attendSpecialEventId = this.selectedAttendSpecialEventId;

    this.isInPunchInOutProccess = true;
    this.isPunchOut = isPunchOut;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.onAfterGetUserGeoLocation, this.onUserRejectGeoLocation,
        {
          timeout: 10000,
          enableHighAccuracy: true
        });
    } else {
      this.onCheckHealthDeclarationPermission();
    }
  }

  onAfterGetUserGeoLocation(location) {
    if (location && location.coords) {
      this.punchInOutModel.latitude = location.coords.latitude;
      this.punchInOutModel.longitude = location.coords.longitude;
      this.punchInOutModel.accuracy = location.coords.accuracy;
    }
    this.onCheckHealthDeclarationPermission();
  }

  onUserRejectGeoLocation() {
    let isAttendLocationMandatory = this.appEnv.isAllowed(AppConstants.Permissions.AttendLocationMandatory);
    if (isAttendLocationMandatory) {
      if (this.appEnv.IsMobileApp) {
        this.onRunLocationPermissionCheck();
      } else {
        this.appEnv.showErrorDialog([{ message: this.$t("msgs.attend_punch_location_disabeld") }]);
      }
      this.isInPunchInOutProccess = false;
    } else {
      this.onCheckHealthDeclarationPermission();
    }
  }

  onRunLocationPermissionCheck() {
    try {
      if (this.appEnv.IsAndroidDevice) {
        var permissionsPlugin = window["cordova"].plugins.permissions;
        var permission = "android.permission.ACCESS_FINE_LOCATION";

        permissionsPlugin.requestPermission(permission, (status) => {
          var onStartPunchProcess = () => {
            this.onStartPunchProcess();
          }

          if (status.hasPermission) {
            console.log('Location permission has been approved');
            onStartPunchProcess();
          } else {
            this.onShowDeviceAppOrLocationSettingsDialog();
          }
        })
      } else {
        this.onShowDeviceAppOrLocationSettingsDialog();
      }
    } catch (error) {
      console.log(`onRunLocationPermissionCheck - General Error - ${error}`);
    }
  }

  onShowDeviceAppOrLocationSettingsDialog() {
    this.$q.dialog({
      title: this.$t('msgs.error'),
      message: this.$t('msgs.location_permission_disabeld'),
      cancel: this.$t('reject'),
      ok: this.$t('approve'),
      persistent: true,
      html: false,
      focus: "none",
      class: ""
    }).onOk(() => {
      this.onOpenDeviceAppOrLocationSettings();
    }).onCancel(() => {
    })
  }

  onOpenDeviceAppOrLocationSettings() {
    var settingsPlugin = window["cordova"].plugins.settings;
    let setting = this.appEnv.IsAndroidDevice ? "application_details" : "locations";
    console.log('Try to open application details');
    settingsPlugin.open(setting,
      function () {
        console.log('opened app settings');
      },
      function () {
        console.log('failed to open app settings');
      }
    );
  }

  onCheckHealthDeclarationPermission() {
    if (this.isPunchOut) {
      this.onPunchInOut();
    } else {
      let showHealthDeclration = this.appEnv.isAllowed(AppConstants.Permissions.HealthDeclaration);
      if (showHealthDeclration) {
        this.appEnv.isBusy = true;
        apiService.get(`Portal/employee/checkHealthDeclration`)
          .then(res => {
            let result = res as Interfaces.iServiceRequest;
            let call = result.calls[0];
            if (call && call.isSuccess) {
              let isHealthDeclarationFilledForToday = call.callResult.isHealthDeclarationFilledForToday;
              if (!isHealthDeclarationFilledForToday) {
                this.onShowHealthDeclarationModal();
              } else {
                this.punchInOutModel.isHealthDeclarationFilledForToday = true;
                this.onPunchInOut();
              }
            } else {
              this.appEnv.showErrorDialog(call.msgs.msgs);
            }
            this.isInPunchInOutProccess = false;
            this.appEnv.isBusy = false;
          })
          .then(err => {
            this.isInPunchInOutProccess = false;
            this.appEnv.isBusy = false;
          })
      } else {
        this.punchInOutModel.isHealthDeclarationFilledForToday = true;
        this.onPunchInOut();
      }
    }
  }

  onShowHealthDeclarationModal(isFromPunchInOut: boolean = true) {
    this.$q.dialog({
      title: this.$t('health_declaration.title'),
      message: this.$t('health_declaration.message'),
      cancel: this.$t('reject'),
      ok: this.$t('approve'),
      persistent: true,
      html: true,
      focus: "none",
      class: "health_declaration_dialog"
    }).onOk(() => {
      this.onHealthDeclarationModalClosed(true, isFromPunchInOut);
    }).onCancel(() => {
      this.onHealthDeclarationModalClosed(false, isFromPunchInOut);
    })
  }

  onHealthDeclarationModalClosed(isApproved: boolean, isFromPunchInOut: boolean) {
    if (isFromPunchInOut) {
      this.punchInOutModel.isHealthDeclarationApproved = isApproved;
      this.onPunchInOut(isApproved);
    } else {
      this.onSaveHealthDeclarationOnly(isApproved);
    }
  }

  onPunchInOut(showSuccessNotify: boolean = true) {
    this.punchInOutModel.timeZone = new Date().getTimezoneOffset() / -60;
    this.punchInOutModel.additionalEmployeeId = 0;
    if (this.appEnv.UserInfo.primaryEmployeeId != this.appEnv.UserInfo.employeeId) {
      this.punchInOutModel.additionalEmployeeId = this.appEnv.UserInfo.employeeId;
    }

    let isAttendLocationMandatory = this.appEnv.isAllowed(AppConstants.Permissions.AttendLocationMandatory);
    if (isAttendLocationMandatory && this.punchInOutModel.latitude == 0 && this.punchInOutModel.longitude == 0) {
      this.appEnv.showErrorDialog([{ message: this.$t("msgs.attend_punch_location_disabeld") }]);
      return;
    }

    this.isInPunchInOutProccess = true;
    let urlPath = this.isPunchOut ? "Portal/employee/punchout" : "Portal/employee/punchin";
    this.appEnv.isBusy = true;
    apiService
      .post(urlPath, this.punchInOutModel)
      .then(res => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0];
        if (call && call.isSuccess) {
          if (this.punchInOutModel.isHealthDeclarationApproved || this.punchInOutModel.isHealthDeclarationFilledForToday) this.appEnv.setShowHealthDeclaration(false);
          this.onAfterPunchInOut(call);
          this.onCloseRightDrawerAfterAction();
          let msgText = this.isPunchOut ? this.$t("msgs.punchOutSuccsess") : this.$t("msgs.punchInSuccsess");
          if (showSuccessNotify) {
            this.$q.notify({
              message: msgText,
              color: "positive",
              timeout: 2000,
              icon: "thumb_up",
              position: "center"
            });
            this.punchInOutModel.attendSpecialEventId = 0;
            this.isAttendSpecialEventVisible = false;
          }
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      })
      .catch(err => {
      })
      .finally(() => {
        this.selectDefaultAttendSpecialEventSelectOption();
        this.isInPunchInOutProccess = false;
        this.appEnv.isBusy = false;
      })
  }

  onSaveHealthDeclarationOnly(isApproved: boolean) {
    this.isInPunchInOutProccess = true;
    this.appEnv.isBusy = true;
    apiService.saveHealthDeclration(isApproved)
      .then(res => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0];
        if (call && call.isSuccess) {
          if (isApproved) this.appEnv.setShowHealthDeclaration(false);
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.isInPunchInOutProccess = false;
        this.appEnv.isBusy = false;
      })
      .catch(err => {
        this.isInPunchInOutProccess = false;
        this.appEnv.isBusy = false;
      })
  }

  onActivateApprovalsList() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, AppConstants.DrawerComponnents.ApprovalsList);
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, { employeeId: this.appEnv.UserInfo.employeeId, isFromManager: false });
  }

  onAfterPunchInOut(call: Interfaces.iServiceCall) {
    if (this.$route.name == AppConstants.Routes.M_PersonalArea ||
      this.$route.name == AppConstants.Routes.E_PersonalArea) {
      if (call.callResult.shouldCalcByServer) {
        store.dispatch(AppConstants.StoreActions.GetEmployeeMonthAttendViewData);
      } else {
        let amrLineDay = call.callResult.amrLineDay;        
        let dayIndex = this.employeeAttendViewData.lines.findIndex((x) => x.id == amrLineDay.id || x.date == amrLineDay.date);
        if (dayIndex < 0) return;
        this.$set(this.employeeAttendViewData.lines, dayIndex, amrLineDay);
      }
    }
  }

  set employeeAttendViewData(value) {
    store.commit(
      AppConstants.StoreMutations.UpdateEmployeeAttendViewData,
      value
    );
  }

  get employeeAttendViewData() {
    return store.getters.employeeAttendViewData;
  }

  generateYears(yearBack: number, yearFoward: number) {
    var years = [];
    let currentYear = new Date().getFullYear();
    for (let index = 1; index <= yearBack; index++) {
      years.push({
        label: (currentYear - index).toString(),
        value: currentYear - index,
      });
    }

    years.push({ label: currentYear.toString(), value: currentYear });

    for (let index = 1; index <= yearFoward; index++) {
      years.push({
        label: (currentYear + index).toString(),
        value: currentYear + index,
      });
    }

    years.sort((a, b) => {
      return a.value - b.value;
    });

    return years;
  }

  generateMonths(start, end) {
    var months = [];
    for (var month = start; month <= end; month++) {
      months.push({
        label: this.$t("months." + month.toString()),
        value: month
      });
    }
    return months;
  }

  getActiveFontWeight(routeName: string) {
    return this.$route.name == this.routePrefix + routeName
      ? "active_route_button"
      : "";
  }

  getActiveColor(routeName: string) {
    return this.$route.name == this.routePrefix + routeName ? "white" : "";
  }

  getActiveTextColor(routeName: string) {
    return this.$route.name == this.routePrefix + routeName
      ? "primary"
      : "white";
  }

  getFlat(routeName: string) {
    return this.$route.name != this.routePrefix + routeName;
  }

  selectDefaultAttendSpecialEventSelectOption(): void {
    if (this.appEnv.UserInfo.forceSpecialEvent && this.attendSpecialEventSelectOptions.length == 2) {
      this.selectedAttendSpecialEventId = this.attendSpecialEventSelectOptions[1].id;
    }
    else {
      this.selectedAttendSpecialEventId = 0;
    }
  }

  get isAdditionalJobsEnabled() {
    // return this.appEnv.UserInfo.isAdditionalJobsEnabled && this.empAdditionalJobSelectOptions.length > 1;
    return this.empAdditionalJobSelectOptions.length > 1;
  }

  get isTeamLeaderReporting() {
    return (this.appEnv.UserInfo.isTeamLeaderReporting && this.appEnv.UserInfo.isTeamLeaderReportEmp)
  }

  get employeeAdditionalJobKey() {
    return store.getters.employeeAdditionalJobKey;
  }

  set selectedEmpAdditionalJobId(value) {
    store.commit(AppConstants.StoreMutations.UpdateSelectedEmpAdditionalJobId, value);
  }

  get selectedEmpAdditionalJobId() {
    return store.getters.selectedEmpAdditionalJobId;
  }

  get empAdditionalJobSelectOptions() {
    return store.getters.employeeAdditionalJobs;
  }

  get isAllowPunchSpecialEventActivity() {
    if (
      this.appEnv.isAllowed(
        AppConstants.Permissions.PunchSpecialEventActivity
      )
    ) {
      return true;
    }
    return false;
  }

  get isPunchInOutVisible() {
    let empAttendReadyOnly = this.appEnv.isAllowed(AppConstants.Permissions.EmpAttendReadyOnly);
    let punch = this.appEnv.isAllowed(AppConstants.Permissions.Punch);
    if (empAttendReadyOnly) {
      return false;
    } else {
      return punch;
    }
  }

  get approvalsButtonLabel() {
    return this.$t('approvlas.sign_reports', [this.noOfApprovals]);
  }

  get noOfApprovals() {
    return store.getters.noOfApprovals;
  }

  get hasApprovlas() {
    return store.getters.hasApprovlas;
  }

  get routePath() {
    return this.appEnv.UserInfo.isManager ? "manager" : "employee";
  }

  get routePrefix() {
    return this.appEnv.UserInfo.isManager ? "M_" : "E_";
  }

  set isRightDrawerOpenLocal(value) {
    this.$emit("update:isRightDrawerOpen", value);
  }

  get isRightDrawerOpenLocal() {
    return this.isRightDrawerOpen;
  }

  get leftDrawerComponnent() {
    return store.getters.leftDrawerComponnent;
  }

  set isLeftDrawerOpen(value) {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, value);
  }

  get isLeftDrawerOpen() {
    return store.getters.isLeftDrawerOpen;
  }

  set selectedYear(value) {
    store.commit(AppConstants.StoreMutations.UpdateSelectedYear, value);
  }

  get selectedYear() {
    return store.getters.selectedYear;
  }

  get selectedMonth() {
    return store.getters.selectedMonth;
  }

  set selectedMonth(value) {
    store.commit(AppConstants.StoreMutations.UpdateSelectedMonth, value);
  }

  get isAllowPortalEnableAddReason() {
    if (this.appEnv.isAllowed(AppConstants.Permissions.PortalEnableAddReason)) return true;
    return false;
  }

  get appEnv() {
    return store.state.appEnv;
  }
}
